import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import {
  MessageRetailerOrBrandButton,
  NEED_MORE_INFO,
  additionalDataRequiredForContactingRetailerOrBrandCTA,
} from "../../shared/instantAnswerUtils";

export const ItemDelayedIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (_context) => {
      return NEED_MORE_INFO(strictLocalize);
    },

    descriptionBuilder: (_context) => {
      return [SORRY_FOR_YOUR_ISSUES(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.label;
      },
      onClickFunctionBuilder: (context) => {
        return MessageRetailerOrBrandButton(context, strictLocalize)?.onClick;
      },
    },

    additionalRequiredData:
      additionalDataRequiredForContactingRetailerOrBrandCTA(),
  };
};

const SORRY_FOR_YOUR_ISSUES = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "We’re sorry to hear that you’re having issues with your order. Please message the brand or contact us if you need more help.",
  });
